module.exports = __webpack_public_path__ + "static/media/geoffpleiss_cv.6ca8528f.pdf";